import { MessageCircle, Phone, CalendarDays, ArrowRight } from "lucide-react";
import { ZORBA, whatsappLink, ANALYTICS_EVENTS } from "../data/content";

const track = (name, detail = {}) =>
  window.dispatchEvent(new CustomEvent("spa-analytics", { detail: { name, ...detail } }));

export function WhatsAppButton({ message, className = "btn btn-primary", label = "WhatsApp now", source = "generic", testid = "whatsapp-cta" }) {
  return (
    <a
      className={className}
      href={whatsappLink(message)}
      target="_blank"
      rel="noreferrer"
      data-testid={testid}
      onClick={() => track(ANALYTICS_EVENTS.whatsappClick, { source })}
    >
      <MessageCircle size={17} /> {label}
    </a>
  );
}

export function CallButton({ className = "btn btn-secondary", label = "Call now", source = "generic", testid = "call-cta" }) {
  if (!ZORBA.phone) {
    return (
      <button
        className={className}
        disabled
        title="Phone details will be added when supplied by our partner spa"
        data-testid={testid}
      >
        <Phone size={17} /> Phone to be confirmed
      </button>
    );
  }
  return (
    <a
      className={className}
      href={`tel:${ZORBA.phone}`}
      data-testid={testid}
      onClick={() => track(ANALYTICS_EVENTS.callClick, { source })}
    >
      <Phone size={17} /> {label}
    </a>
  );
}

export function BookButton({ onBook, className = "btn btn-primary", label = "Book an enquiry", service, testid = "book-cta" }) {
  return (
    <button className={className} data-testid={testid} onClick={() => onBook(service)}>
      <CalendarDays size={17} /> {label} <ArrowRight size={15} />
    </button>
  );
}

export function DirectionsButton({ className = "btn btn-secondary", testid = "directions-cta" }) {
  if (!ZORBA.mapUrl) {
    return (
      <button
        className={className}
        disabled
        title="Map link will be added when supplied by our partner spa"
        data-testid={testid}
      >
        Directions coming soon
      </button>
    );
  }
  return (
    <a
      className={className}
      href={ZORBA.mapUrl}
      target="_blank"
      rel="noreferrer"
      data-testid={testid}
      onClick={() => track(ANALYTICS_EVENTS.directionsClick)}
    >
      Get directions
    </a>
  );
}
